
<div class="container-nm px-4 pt-4 w-100 mx-auto step_mobile" style="box-sizing: border-box;">
    <div class="title-page">
        <span>{{ 'stenTwo.txtTitle' | translate }}</span>
    </div>
    <div class="line"></div>
    <div class="description-page">
        <span>{{ 'stenTwo.txtDescription' | translate }}</span>
    </div>
    <div class="d-flex mx-auto justify-content-center align-items-center mobile-not-active">
        <div class="d-flex flex-column justify-content-center align-items-center gap-3 shadowBl" (click)="goToCreateGame()">            
            <div class="icon">
                <img src="./assets/slot_2.png" />
            </div>
            <span>{{ 'stenTwo.txtOnOnesOwn' | translate }}</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center gap-3 shadowBl" (click)="goToStepTwo()">
            <div class="icon">
                <img src="./assets/slot_3.png" />
            </div>
            <span>{{ 'stenTwo.txtTeams' | translate }}</span>
        </div>
    </div>
    
    <div class="d-flex mx-auto justify-content-center align-items-center mt-3 mobile-not-active">
        <div class="d-flex justify-content-center align-items-center block-info-game">
            <span>
                {{ 'stenTwo.txtTextL' | translate }}
            </span>
        </div>
        <div class="d-flex justify-content-center align-items-center block-info-game">
            <span>
                {{ 'stenTwo.txtTextR' | translate }}
            </span>
        </div>
    </div>

    <div class="d-flex justify-content-between align-items-center px-4375 my-23125 mobile-not-active">
            <div class="d-flex justify-content-start align-items-center w-100 mobile-step-1">
                <div class="d-flex justify-content-start align-items-center left-complex-button" (click)="goToPrev()">
                    <button matIconButton class="example-icon d-flex justify-content-center align-items-center">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.83325 15.8333V14.1666H11.7499C12.6249 14.1666 13.3853 13.8888 14.0312 13.3333C14.677 12.7777 14.9999 12.0833 14.9999 11.2499C14.9999 10.4166 14.677 9.72214 14.0312 9.16659C13.3853 8.61103 12.6249 8.33325 11.7499 8.33325H6.49992L8.66658 10.4999L7.49992 11.6666L3.33325 7.49992L7.49992 3.33325L8.66658 4.49992L6.49992 6.66659H11.7499C13.0971 6.66659 14.2534 7.10409 15.2187 7.97909C16.1839 8.85409 16.6666 9.94436 16.6666 11.2499C16.6666 12.5555 16.1839 13.6458 15.2187 14.5208C14.2534 15.3958 13.0971 15.8333 11.7499 15.8333H5.83325Z" fill="#262626"/>
                        </svg>
                    </button>
                    <span class="sub-button-title">{{ 'buttons.txtBack' | translate }}</span>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center w-100 mobile-step-2">
            </div>
            <div class="d-flex justify-content-end align-items-center w-100 mobile-step-3"></div>
        </div>

    <div class="mobile-active">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="{{ 'stenTwo.txtOnOnesOwn' | translate }}">
                <div class="p-3 d-flex flex-column justify-content-center align-items-center gap-3 shadowBl mt-3">            
                    <div class="icon">
                        <img src="./assets/slot_2.png" />
                    </div>
                    <span>{{ 'stenTwo.txtOnOnesOwn' | translate }}</span>
                </div>
                <div class="p-3 d-flex justify-content-center align-items-center block-info-game mt-2">
                    <span>
                        {{ 'stenTwo.txtTextL' | translate }}
                    </span>
                </div>
            </mat-tab>
            <mat-tab label="{{ 'stenTwo.txtTeams' | translate }}">
                <div class="p-3 d-flex flex-column justify-content-center align-items-center gap-3 shadowBl mt-3">
                    <div class="icon">
                        <img src="./assets/slot_3.png" />
                    </div>
                    <span>{{ 'stenTwo.txtTeams' | translate }}</span>
                </div>
                <div class="p-3 d-flex justify-content-center align-items-center block-info-game mt-2">
                    <span>
                        {{ 'stenTwo.txtTextR' | translate }}
                    </span>
                </div>
            </mat-tab>
        </mat-tab-group>
        <div class="d-flex justify-content-between align-items-center px-4375 my-23125 mt-3">
            <div class="d-flex justify-content-start align-items-center w-100 mobile-step-1">
                <div class="d-flex justify-content-start align-items-center left-complex-button" (click)="goToPrev()">
                    <button matIconButton class="example-icon d-flex justify-content-center align-items-center">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.83325 15.8333V14.1666H11.7499C12.6249 14.1666 13.3853 13.8888 14.0312 13.3333C14.677 12.7777 14.9999 12.0833 14.9999 11.2499C14.9999 10.4166 14.677 9.72214 14.0312 9.16659C13.3853 8.61103 12.6249 8.33325 11.7499 8.33325H6.49992L8.66658 10.4999L7.49992 11.6666L3.33325 7.49992L7.49992 3.33325L8.66658 4.49992L6.49992 6.66659H11.7499C13.0971 6.66659 14.2534 7.10409 15.2187 7.97909C16.1839 8.85409 16.6666 9.94436 16.6666 11.2499C16.6666 12.5555 16.1839 13.6458 15.2187 14.5208C14.2534 15.3958 13.0971 15.8333 11.7499 15.8333H5.83325Z" fill="#262626"/>
                        </svg>
                    </button>
                    <span class="sub-button-title">{{ 'buttons.txtBack' | translate }}</span>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center w-100 mobile-step-2">
                <button type="button" class="d-flex justify-content-center align-items-center gap-2 btn-next " (click)="goToNextRoom()">
                    <span>{{ 'buttons.txtNext' | translate }}</span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 18L12.6 16.55L16.15 13H4V11H16.15L12.6 7.45L14 6L20 12L14 18Z" fill="white"/>
                    </svg>
                </button>
            </div>
            <div class="d-flex justify-content-end align-items-center w-100 mobile-step-3"></div>
        </div>
        
    </div>
    
</div>
